import { ElementType } from 'react';

import * as actionsTypes from './types';
import { LinkParams, ImageState, ClientRoom, WidgetSettings, NotificationType } from '../types';

export function toggleChat(): actionsTypes.ToggleChat {
  return {
    type: actionsTypes.TOGGLE_CHAT
  };
}

export function toggleInputDisabled(): actionsTypes.ToggleInputDisabled {
  return {
    type: actionsTypes.TOGGLE_INPUT_DISABLED
  };
}

export function changeButtonStartStateAction(showStart: boolean): actionsTypes.ChangeButtonStartState {
  return {
    type: actionsTypes.CHANGE_BUTTON_START_STATE,
    showStart
  };
}

export function addUserMessage(message: Omit<actionsTypes.AddUserMessage, 'type'> ): actionsTypes.AddUserMessage {
  return {
  ...message,
    type: actionsTypes.ADD_NEW_USER_MESSAGE,
  };
}

export function addResponseMessage(message: Omit<actionsTypes.AddResponseMessage, 'type'> ): actionsTypes.AddResponseMessage {
    return {
  ...message,
    type: actionsTypes.ADD_NEW_RESPONSE_MESSAGE,
  };
}
 
export function addTranscriptionMessage({ text, datetime, final }: { text: string, final?: boolean, datetime?: Date }): actionsTypes.AddTranscriptionMessage {
  return {
    type: actionsTypes.ADD_NEW_TRANSCRIPTION_MESSAGE,
    text,
    timestamp: datetime,
    final,
  };
}

export function toggleConnectionAwaiting(status?: boolean): actionsTypes.ToggleConnectionAwaiting {
  return {
    type: actionsTypes.TOGGLE_CONNECTION_AWAIT,
    status
  }
}

export function toggleMsgLoader(): actionsTypes.ToggleMsgLoader {
  return {
    type: actionsTypes.TOGGLE_MESSAGE_LOADER
  }
}

export function addLinkSnippet(link: LinkParams, id?: string): actionsTypes.AddLinkSnippet {
  return {
    type: actionsTypes.ADD_NEW_LINK_SNIPPET,
    link,
    id
  };
}

export function renderCustomComponent(
  component: ElementType,
  props: any,
  showAvatar: boolean,
  id?: string
): actionsTypes.RenderCustomComponent {
  return {
    type: actionsTypes.ADD_COMPONENT_MESSAGE,
    component,
    props,
    showAvatar,
    id
  };
}

export function dropMessages(): actionsTypes.DropMessages {
  return {
    type: actionsTypes.DROP_MESSAGES
  };
}

export function hideAvatar(index: number): actionsTypes.HideAvatar {
  return {
    type: actionsTypes.HIDE_AVATAR,
    index
  };
}

export function setQuickButtons(buttons: Array<{ label: string, value: string | number }>): actionsTypes.SetQuickButtons {
  return {
    type: actionsTypes.SET_QUICK_BUTTONS,
    buttons
  }
}

export function deleteMessages(count: number, id?: string): actionsTypes.DeleteMessages {
  return {
    type: actionsTypes.DELETE_MESSAGES,
    count,
    id
  }
}

export function setBadgeCount(count: number): actionsTypes.SetBadgeCount {
  return {
    type: actionsTypes.SET_BADGE_COUNT,
    count
  }
}

export function markAllMessagesRead(): actionsTypes.MarkAllMessagesRead {
  return {
    type: actionsTypes.MARK_ALL_READ
  }
}

export function markAck(id: string, acknowledged: boolean): actionsTypes.MarkAck {
  return {
    type: actionsTypes.MARK_ACK,
    id
  }
}

export function markError(id: string): actionsTypes.MarkError {
  return {
    type: actionsTypes.MARK_ERROR,
    id
  }
}

export function openFullscreenPreview(payload: ImageState): actionsTypes.FullscreenPreviewActions {
  return {
    type: actionsTypes.OPEN_FULLSCREEN_PREVIEW,
    payload
  };
}

export function closeFullscreenPreview(): actionsTypes.FullscreenPreviewActions {
  return {
    type: actionsTypes.CLOSE_FULLSCREEN_PREVIEW
  };
}

export function addClientRoomInformation(payload: ClientRoom): actionsTypes.addClientRoomInformation {
  console.log('payload', payload)
  return {
    type: actionsTypes.ADD_CLIENT_ROOM_INFORMATION,
    payload: payload
  };
}

export function updateUserDataStateAction(userData: actionsTypes.UpdateUserDataState['userData']): actionsTypes.UpdateUserDataState {
  return {
    type: actionsTypes.UPDATE_USER_DATA,
    userData
  };
}

export function setUserAuthorizedStateAction(isUserAuthorized: actionsTypes.SetUserAuthorizedState['isUserAuthorized']): actionsTypes.SetUserAuthorizedState {
  return {
    type: actionsTypes.SET_USER_AUTHORIZED,
    isUserAuthorized
  };
}

export function setOperatorPrinting(isPrinting: boolean): actionsTypes.SetOperatorPrinting {
  return {
    type: actionsTypes.SET_OPERATOR_PRINTING,
    isPrinting
  };
}

export const updateWidgetSettings = (settings: WidgetSettings): actionsTypes.UpdateWidgetSettingsAction  => ({
  type: actionsTypes.UPDATE_WIDGET_SETTINGS,
  settings,
});

export function showNotification(message: string, type: NotificationType): actionsTypes.ShowNotificationAction {
  return {
    type: actionsTypes.SHOW_NOTIFICATION,
    payload: { message, type },
  };
}

export function hideNotification(): actionsTypes.HideNotificationAction {
  return {
    type: actionsTypes.HIDE_NOTIFICATION,
  };
}
